import React from 'react';
import './Loading.css';

export default function Loading() {
  return (
    <section className="loading">
      <h2>Loading Launches...</h2>
      <h3>Please wait</h3>
    </section>
  );
}
